<template>
  <div class="dynamic-component" v-if="config.visible !== false" :style="layoutStyle">
    <component
      :is="componentName"
      :config="config.data || {}"
      :priceData="priceData"
      @action="handleAction"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
// 导入所有可动态渲染的组件
import BannerSection from './BannerSection.vue'
import MarqueeNotice from './MarqueeNotice.vue'
import CountdownTimer from './CountdownTimer.vue'
import FormSection from './FormSection.vue'
import BenefitsSection from './BenefitsSection.vue'
import OrderNotice from './OrderNotice.vue'
import ProductInfo from './ProductInfo.vue'
import PriceSelector from './PriceSelector.vue'
import AgreementSection from './AgreementSection.vue'

// 组件映射表
const componentMap = {
  BannerSection,
  MarqueeNotice,
  CountdownTimer,
  FormSection,
  BenefitsSection,
  OrderNotice,
  ProductInfo,
  PriceSelector,
  AgreementSection
}

export default {
  name: 'DynamicComponent',
  props: {
    config: {
      type: Object,
      required: true
    },
    // 价格选择器的数据，从父组件传递
    priceData: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    componentName() {
      return componentMap[this.config.type] || null
    },
    layoutStyle() {
      const layout = this.config.data && this.config.data.layout
      if (!layout) return {}
      const style = {}
      if (layout.marginTop) style.marginTop = layout.marginTop
      if (layout.marginBottom) style.marginBottom = layout.marginBottom
      if (layout.paddingTop) style.paddingTop = layout.paddingTop
      if (layout.paddingBottom) style.paddingBottom = layout.paddingBottom
      if (layout.paddingLeft) style.paddingLeft = layout.paddingLeft
      if (layout.paddingRight) style.paddingRight = layout.paddingRight
      if (layout.backgroundColor) style.backgroundColor = layout.backgroundColor
      if (layout.borderRadius) style.borderRadius = layout.borderRadius
      return style
    }
  },
  methods: {
    handleAction(action) {
      this.$emit('action', {
        componentId: this.config.id,
        componentType: this.config.type,
        ...action
      })
    },
    handleSubmit(data) {
      this.$emit('submit', data)
    }
  }
}
</script>

<style lang="less" scoped>
.dynamic-component {
  width: 100%;
}
</style>
